import React from 'react';
import { useSurvey } from './Context';
import QuestionNavigateBtn from './QuestionNavigateBtn';

function QuestionPanel() {
    const { currentQuestion, chartData } = useSurvey();

    if (!currentQuestion) {
        return null;
    }

    return (
        <div className="question-panel">
            <div className="panel-info">
                <p className="selected-text"><strong>Selected Question</strong>{chartData?.question?.respondents_count != null ? ` (${Number(chartData.question.respondents_count).toLocaleString()} respondents)` : ''}</p>
                {/* <p className="info-text">Collected</p> */}
                <ul className="panel-controls">
                    <li className="control-item">
                        <QuestionNavigateBtn isNext={false} />
                    </li>
                    <li className="control-item">
                        <QuestionNavigateBtn isNext={true} />
                    </li>
                </ul>
            </div>
            <div className="panel-main">
                <p>{currentQuestion.text}</p>
                { [44, 45, 46, 47].includes(currentQuestion.id) && (
                    <p><small><em>*1/4 of participants were asked this question</em></small></p>
                )}
            </div>
            {/* <div className="panel-aux">
                Note: You'll need to create a SocialShare component or import it
                <SocialShare className="alt-icons" />
            </div> */}
        </div>
    );
}

export default QuestionPanel;
